<template>
  <page>
    <div></div>
  </page>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
    // https://beta-tvshop.coocaa.com/ad-link/ccfx?pageType=purchase&target=https://beta-tvshop.coocaa.com
    // pageType = purchase  批量采购
    // pageType=employee  合伙人绑定 或空
    const routeQuery = this.$route.query
    const pageType = routeQuery.pageType
    const fromCode = routeQuery.fromCode
    const target = decodeURIComponent(routeQuery.target)
    if (pageType === 'purchase' || pageType === 'normal') {
      this.$constants.setStorage('showType', pageType, null)
      window.location = target
      // 批量采购
    } else if (pageType === 'employee' || !pageType) {
      // 合伙人绑定
      if (fromCode !== 'undefined' && fromCode !== null && fromCode) {
        this.$setCookie('fromCode', fromCode, 15)
        this.$service.bindEmployee({
          empNo: fromCode
        }).then((res) => {
          console.log('绑定合伙人成功，绑定ID', fromCode)
          window.location = target
        })
      } else {
        window.location = target
      }
    } else if (pageType === 'applyEmp') {
      // 记录分销预备合伙人id
      // this.setShareApplyId(fromCode)
      // 因为存在路由跳转,后续无法读取vuex的内容 产品沟通说要记录30天 先试试效果
      this.$setCookie('shareApplyId', fromCode, 30)
      window.location = target
    } else if (pageType == 'collage') {
      if (routeQuery.shareApplyId) {
        // 记录分销预备合伙人id 需要计算预备合伙人分享团的分销额
        this.$setCookie('shareApplyId', routeQuery.shareApplyId, 30)
      }
      const orderSn = routeQuery.orderSn
      const groupCode = routeQuery.groupCode
      window.location = `${target}?groupCode=${groupCode}&orderSn=${orderSn}`
    } else {
      window.location = target || '/'
    }
  }
}
</script>
